import styled from 'styled-components'
// themes
import { colors } from 'themes/index'
// types
import { ComposerPrimitive } from '@assistant-ui/react'

export const AttachedFilesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0 20px 8px;
`

export const AttachButton = styled.button`
  background: ${colors.purple300};
  border: none;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: ${colors.white100};
  flex-shrink: 0;

  &:hover {
    opacity: 0.85;
  }
`

export const StyledComposerRoot = styled(ComposerPrimitive.Root)<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 6px 12px;
  margin: 20px;
  border: 1px solid ${colors.gray240};
  border-radius: 24px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;

  textarea {
    overflow: auto;

    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &:focus-within {
    border: 1px solid ${colors.purple300};
  }

  ${({ $disabled }) =>
    $disabled &&
    `
    opacity: 0.6;
    pointer-events: none;
  `}
`

export const StyledComposerInput = styled(ComposerPrimitive.Input)`
  flex: 1;
  color: ${colors.black};
  border: none;
  padding: 10px 14px;
  font-size: 16px;
  line-height: 1.5;
  resize: none;
  min-height: 42px;
  max-height: 120px;
  font-family: inherit;
  outline: none;

  &::placeholder {
    color: ${colors.gray300};
  }

  &:focus {
    border-color: ${colors.purple300};
  }

  &:disabled {
    cursor: not-allowed;
    background: transparent;
  }
`

export const StyledSendButton = styled(ComposerPrimitive.Send)`
  background: ${colors.purple300};
  border: none;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: ${colors.white100};
  flex-shrink: 0;

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:disabled {
    display: none;
  }
`

export const StyledCancelButton = styled(ComposerPrimitive.Cancel)`
  background: ${colors.purple300};
  border: none;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: ${colors.white100};
  flex-shrink: 0;

  &:hover {
    opacity: 0.85;
  }
`

export const ComposerDisclaimer = styled.p`
  text-align: center;
  font-size: 12px;
  color: ${colors.gray380};
  margin: -12px 0 8px;
`

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const FileInput = styled.input`
  display: none;
`
